'use strict';

const root = require('bunsen/helpers/windowCheck');
const {PropTypes} = require('react');
const BuyerAssuranceTooltipView = require('../../../components/BuyerAssurance/BuyerAssuranceTooltip-view');

/**
 * Extending the global BuyerAssuranceTooltip in order to add pdp specific listeners when the tooltip is mounted and unmounted
 */
class BuyerAssuranceTooltip extends BuyerAssuranceTooltipView {
    componentWillMount() {
        root.addEventListener('scroll', this.props.hideTooltip);
        root.addEventListener('click', this.props.hideTooltip);
    }

    componentWillUnmount() {
        root.removeEventListener('scroll', this.props.hideTooltip);
        root.removeEventListener('click', this.props.hideTooltip);
    }
}

// parent component (PdpBuyerAssurance) only calls to render this component if it should be shown
BuyerAssuranceTooltip.defaultProps = {
    showInfo : true
};

BuyerAssuranceTooltip.propTypes = {
    trackLinkClick: PropTypes.func,
    hideTooltip: PropTypes.func.isRequired,
    copy: PropTypes.shape({
        title: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
    })
};

module.exports = BuyerAssuranceTooltip;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/BuyerAssurance/BuyerAssuranceTooltip.jsx